













































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import ExtensionCategoryModel from '@/models/extension/extensionCategoryModel'
import ExtensionCategoryListModel from '@/models/extension/extensionCategoryListModel'
import ExtensionCategoryCreateModel from '@/models/extension/extensionCategoryCreateModel'
import QuestionListAdmin from '@/components/lists/QuestionListAdmin.vue'
import AddDialog from '@/components/dialogs/AddDialog.vue'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule.ts'
import ExtensionModule from '@/store/extensionModule.ts'
import StageConstants from '@/constants/stageConstants.ts'
import LoadingIndicator from '@/components/loading/LoadingIndicator.vue'
import ExtensionCategoryQuestionModel from '@/models/extension/extensionCategoryQuestionModel'
import ExtensionCategoryQuestionCreateModel from '@/models/extension/extensionCategoryQuestionCreateModel'
import Validation from '@/mixins/validation.ts'
import ExtenstionCategoryListModel from '@/models/extension/extensionCategoryListModel'
import apiService from '@/services/apiService'

const titleModule = getModule(TitleModule)
const extensionModule = getModule(ExtensionModule)

@Component({
  components: {
    QuestionListAdmin,
    AddDialog,
    LoadingIndicator
  }
})
export default class StageAdmin extends Mixins(Validation) {
  @Prop(String) readonly stage!: string

  private stageKey: string = ''
  private dialog: boolean = false
  private dialogCatalog: boolean = false
  private categories: Array<ExtensionCategoryListModel> = []
  private category: string | ExtenstionCategoryListModel = ''
  private editCategoryModel: ExtensionCategoryModel = new ExtensionCategoryModel()
  private loading: boolean = true
  private question: ExtensionCategoryQuestionModel = new ExtensionCategoryQuestionModel()
  private valid: boolean = true
  private isEdit: boolean = false

  get formattedStage() {
    const stageName = this.stage.replace(/-/g, ' ')
    return stageName.charAt(0).toUpperCase() + stageName.slice(1)
  }

  get modalTitle() {
    return this.isEdit ? 'Edit Question' : 'New Question'
  }

  get categoryModalTitle() {
    return 'Edit Category'
  }

  private async created() {
    this.stageKey = StageConstants.getKeyByValue(this.stage)
    titleModule.setPageTitle(this.formattedStage)
    this.subscribeToModalOpen()
    await this.getCategories()
  }

  private async getCategories(): Promise<void> {
    this.categories = await ApiService.getQuestionsByExtension<
      ExtensionCategoryListModel
    >(UrlType.ExtensionCategory, extensionModule.getExtensionId, this.stageKey)
    this.loading = false
  }

  private async editQuestion(
    question: ExtensionCategoryQuestionModel
  ): Promise<void> {
    this.question = Object.assign({}, question)
    this.isEdit = true

    this.category = await ApiService.get(
      UrlType.ExtensionCategoryBase,
      this.question.extensionCategoryId
    )

    this.dialog = true
  }

  private async moveCategoryDown(id: string) {
    await ApiService.putOrder<ExtensionCategoryListModel>(
      UrlType.ExtensionCategoryBase + '/orderdown',
      id
    )
    await this.getCategories()
  }

  private async moveCategoryUp(id: string) {
    await ApiService.putOrder<ExtensionCategoryListModel>(
      UrlType.ExtensionCategoryBase + '/orderup',
      id
    )
    await this.getCategories()
  }

  private async saveQuestion(valid: boolean): Promise<void> {
    if (valid) {
      try {
        if (this.isEdit) {
          await this.updateQuestion()
        } else {
          await this.createQuestion()
        }
      } finally {
        this.closeDialog()
        await this.getCategories()
      }
    }
  }

  private async createQuestion(): Promise<void> {
    const createModel: ExtensionCategoryCreateModel = {
      category: this.category,
      question: this.question.question,
      stage: this.stageKey,
      extensionId: extensionModule.getExtensionId
    }

    if (typeof createModel.category === 'string') {
      await ApiService.post(
        UrlType.ExtensionCategoryBase + '/categoryQuestion',
        createModel
      )
    } else {
      const selectedCategory = this.category as ExtensionCategoryListModel
      const createQuestion = new ExtensionCategoryQuestionCreateModel()

      createQuestion.extensionCategoryId = selectedCategory.extensionCategoryId
      createQuestion.question = this.question.question
      await ApiService.post(UrlType.ExtensionCategoryQuestion, createQuestion)
    }
  }

  private async updateQuestion(): Promise<void> {
    if (typeof this.category === 'string') {
      // create new category
      const createModel: ExtensionCategoryCreateModel = {
        category: this.category,
        question: '',
        stage: this.stageKey,
        extensionId: extensionModule.getExtensionId
      }

      await ApiService.put(
        UrlType.ExtensionCategoryBase + '/categoryQuestion',
        this.question.extensionCategoryQuestionId,
        createModel
      )
    } else {
      // just put question
      this.question.extensionCategoryId = this.category.extensionCategoryId

      await ApiService.put(
        UrlType.ExtensionCategoryQuestion,
        this.question.extensionCategoryQuestionId,
        this.question
      )
    }
  }

  private closeDialog(): void {
    this.isEdit = this.dialog = false
    this.dialogCatalog = false
  }

  private subscribeToModalOpen(): void {
    this.$root.$on('openNavbarModal', () => {
      this.dialog = true
    })
  }

  private async editCategory(model: ExtensionCategoryModel) {
    this.editCategoryModel = Object.assign({}, model)
    this.dialogCatalog = true
  }

  private async updateCategory() {
    await apiService.put(
      UrlType.ExtensionCategoryBase,
      this.editCategoryModel.extensionCategoryId,
      this.editCategoryModel
    )
    this.dialogCatalog = false
    await this.getCategories()
  }

  private async deleteCategory(id: string) {
    if (confirm('Are you sure you want to delete this item?')) {
      await ApiService.delete(UrlType.ExtensionCategoryBase, id)
      await this.getCategories()
    }
  }
}
